if(!customElements.get('our-story')) {
  customElements.define(
    'our-story',
    class OurStory extends HTMLElement {
      sliderEl = null;
      sliderInstance = null;

      constructor() {
        super();
      }

      connectedCallback() {
        this.sliderEl = this.querySelector('[data-slider]');
        this.init();
      }
      
      init() {
        if(!this.sliderEl) return console.error("Can't initialize our-story without a slider element");

        this.sliderInstance = new Swiper(this.sliderEl, {
          slidesPerView: 1,
          spaceBetween: 20,
          navigation: {
            prevEl: '.slider-button.our-story-slider-button.prev',
            nextEl: '.slider-button.our-story-slider-button.next',
          },
          pagination: {
            el: '.slider-pagination.our-story-slider-pagination',
            type: 'bullets',
            clickable: true
          }
        });
      }
    }
  )
}